import { render } from "./NewVersionNotification.vue?vue&type=template&id=69c07821"
import script from "./NewVersionNotification.vue?vue&type=script&lang=js"
export * from "./NewVersionNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__